import React, { useContext, useState } from "react";
import { AdditionalServicesList, ContentContainer, WhiteContainer, Actions } from "../../../../../styles/orderform.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import Summary from "./Summary.tsx";
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";

function PhaseThree() {
  const { formValues, handleFormChange, products, addOns, toPhase, leads } = useContext(OrderContext);
  const { t, db_t } = useAppTranslation();
  const [radioAddons] = useState(addOns.filter(addon => addon.group?.label === 'Sähkön alkuperä'));
  const [checkboxAddons] = useState(addOns.filter(addon => addon.group?.label !== 'Sähkön alkuperä' && addon.group?.label !== 'custom'));


  const [showSummary, setShowSummary] = useState(false);

  // give checkbox change event type
  const toggleAdditionalService = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.target as HTMLInputElement;
    const currentServices = formValues['additional-services'].split(',').filter((service: string) => service !== '');
    const newServices = currentServices.includes(value) ? currentServices.filter((service: string) => service !== value) : [...currentServices, value];
    const customTarget = {
      target: {
        name: 'additional-services',
        value: newServices.join(','),
      },
    } as React.ChangeEvent<HTMLInputElement>;
    handleFormChange(customTarget);
  }

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentServices = formValues['additional-services'].split(',').filter((service: string) => service !== '');
    const radioAddonsIds = radioAddons.map(addon => addon.addon_product_template_no);
    // Remove all radio addons from current services
    const newServices = currentServices.filter((service: string) => !radioAddonsIds.includes(service));
    // Add the selected radio addon
    newServices.push(e.target.value);
    const customTarget = {
      target: {
        name: 'additional-services',
        value: newServices.join(','),
      },
    } as React.ChangeEvent<HTMLInputElement>;
    handleFormChange(customTarget);
  }

  const toTop = () => {
    window.scrollTo(0, 0);
  }

  const radioAddonsIds = radioAddons.filter(addon => addon.addon_product_template_no !== '').map(addon => addon.addon_product_template_no);
  const hasAtLeastOneRadioAddonSelected = formValues['additional-services'].split(',').some((service: string) => radioAddonsIds.includes(service));

  return (
    <>
      {!showSummary && (
        <>
          <ContentContainer>
            {radioAddons.length > 0 && (
              <>
                <h3>{t('phaseThree.electricityOrigin')}</h3>
                <AdditionalServicesList>
                  {radioAddons.map(addOn => (
                    <label
                      htmlFor={addOn.hs_id?.toString()}
                      className={'additional-service ' + (addOn.class ? addOn.class : '')}
                      key={addOn.addon_product_template_no}>
                      <div className="header">
                        <input
                          type="radio"
                          id={addOn.hs_id?.toString()}
                          name="additional-services"
                          value={addOn.addon_product_template_no}
                          checked={formValues['additional-services'].split(',').includes(addOn.addon_product_template_no) || (!hasAtLeastOneRadioAddonSelected && addOn.addon_product_template_no === radioAddons[0].addon_product_template_no)}
                          onChange={handleRadioChange} />
                        <div className="title">{t('addonTypes.' + addOn.type.label)}</div>
                      </div>
                      <div className="description" dangerouslySetInnerHTML={{ __html: db_t(addOn, 'description').replaceAll('\\n', '') }}></div>
                      <div className="bottom">
                        {addOn.monthly_price
                          ? (addOn.monthly_price > 0 ? <div className="price">+ {addOn.monthly_price} {t('common.€/month')}</div> : <span>{t('phaseThree.noSurcharge')}</span>)
                          : (addOn.energy_price ? <div className="price">+ {addOn.energy_price} {t('common.c/kWh')}</div> : <span>{t('phaseThree.noSurcharge')}</span>)
                        }
                        {addOn.label && <div className="label image">{db_t(addOn, 'label')}</div>}
                        {addOn.icon && !addOn.label && <img className="image" src={addOn.icon.url} alt={addOn.icon.altText} height={40} width={40} />}
                      </div>
                    </label>
                  ))}
                </AdditionalServicesList>
              </>)}
            {checkboxAddons.length > 0 || leads.length > 0 && (
              <>
                <h3>{t('phaseThree.otherServices')}</h3>
                <AdditionalServicesList>
                  {checkboxAddons.map(addOn => (
                    <label
                      htmlFor={addOn.hs_id.toString()}
                      className={'additional-service ' + (addOn.class ? addOn.class : '')}
                      key={addOn.addon_product_template_no}>
                      <div className="header">
                        <input
                          type="checkbox"
                          id={addOn.hs_id.toString()}
                          name="additional-services"
                          value={addOn.addon_product_template_no}
                          checked={formValues['additional-services'].includes(addOn.addon_product_template_no)}
                          onChange={toggleAdditionalService} />
                        <div className="title">
                          {t('addonTypes.' + addOn.type.label)}
                          {addOn.titleLabel && <div className="title-label label">{db_t(addOn, 'titleLabel')}</div>}
                        </div>
                      </div>
                      <div className="description" dangerouslySetInnerHTML={{ __html: db_t(addOn, 'description') }}></div>
                      <div className="bottom">
                        {addOn.monthly_price
                          ? (addOn.monthly_price > 0 ? <div className="price">+{addOn.monthly_price} {t('common.€/month')}</div> : <span>{t('phaseThree.noSurcharge')}</span>)
                          : (addOn.energy_price ? <div className="price">{addOn.energy_price} {t('common.c/kWh')}</div> : <span>{t('phaseThree.noSurcharge')}</span>)
                        }
                        {addOn.label && <div className="label image">{db_t(addOn, 'label')}</div>}
                        {addOn.icon && !addOn.label && <img className="image" src={addOn.icon.url} alt={addOn.icon.altText} height={40} width={40} />}
                      </div>
                    </label>
                  ))}
                  {leads.map(lead => (
                    <label
                      htmlFor={lead.hs_id.toString()}
                      className='additional-service radio-label'
                      key={lead.hs_id}>
                      <div className="header">
                        <input
                          type="checkbox"
                          id={lead.hs_id.toString()}
                          name="additional-services"
                          value={lead.hs_id}
                          checked={formValues['additional-services'].includes(lead.hs_id.toString())}
                          onChange={toggleAdditionalService} />
                        <div className="title">
                          <div>{db_t(lead, 'name')}</div>
                          {lead.label && <div className="title-label label">{db_t(lead, 'label')}</div>}
                        </div>
                      </div>
                      <div className="bottom" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="description" style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: db_t(lead, 'description') }}></div>
                        {lead.icon && <img className="image" src={lead.icon.url} alt={lead.icon.altText} height={lead.icon.height} width={lead.icon.width} />}
                      </div>
                    </label>
                  ))}
                </AdditionalServicesList>
              </>
            )}
            <Actions>
              <button type="button" className="primary" onClick={() => { setShowSummary(true); toTop(); }}>{t('common.next')}</button>
            </Actions>
          </ContentContainer>
        </>
      )}
      {showSummary && (
        <>
          <ContentContainer>
            <h3>{t('phases.summary')}</h3>
          </ContentContainer>
          <WhiteContainer>
            <Summary></Summary>
          </WhiteContainer>
          <Actions>
            <button type="button" className="primary" onClick={() => toPhase(4)}>{t('common.next')}</button>
          </Actions>


        </>
      )}
    </>
  );
}

export default PhaseThree;
